import { combineReducers } from 'redux';

import completedIds from './completedIds';
import ids from './ids';
import idsInPages from './idsInPages';
import information from './information';
import positions from './positions';
import selectedSignature from './selectedSignature';
import sizes from './sizes';

const inputsReducer = combineReducers({
  completedIds,
  ids,
  idsInPages,
  information,
  positions,
  selectedSignature,
  sizes,
});

export default inputsReducer;
